<template lang="pug">
    div(v-if="isRealtruckBrand(this.brand)" class="flex items-center overflow-hidden")
        img(
            src="@/assets/common/the-r.svg"
            alt=""
            width="28"
            height="26"
        )
</template>

<script>
import IsRealtruckBrandMixin from '@/helpers/isRealtruckBrandMixin'
export default {
    name: 'MadeByRealtruck',
    mixins: [IsRealtruckBrandMixin],
    props: {
        brand: {
            type: String,
            default: null,
        },
    },
}
</script>
